"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchpadLinkTrigger = exports.LaunchpadLinkWrapper = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var stylers_1 = __importDefault(require("@paprika/stylers"));
var tokens_1 = __importDefault(require("@paprika/tokens"));
var GlobalNavigation_styles_1 = require("../../GlobalNavigation.styles");
var withTheme_1 = __importDefault(require("../theme/withTheme"));
var svgWidthHeight = '20px';
exports.LaunchpadLinkWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  margin: 2px 2px 0 0;\n"], ["\n  display: inline-block;\n  margin: 2px 2px 0 0;\n"])));
exports.LaunchpadLinkTrigger = withTheme_1.default(styled_components_1.default.a(function (_a) {
    var isDiligentBrand = _a.isDiligentBrand, isTrainingOrg = _a.isTrainingOrg;
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", "\n      ", "\n      \n      display: flex;\n      align-items: center;\n      padding-top: 2px;\n      color: ", ";\n      ", ";\n\n      &:hover {\n        text-decoration: underline;\n      }\n\n      svg {\n        width: ", ";\n        height: ", ";\n        vertical-align: text-bottom;\n        margin-right: 6px;\n      }\n    "], ["\n      ", "\n      ", "\n      \n      display: flex;\n      align-items: center;\n      padding-top: 2px;\n      color: ", ";\n      ", ";\n\n      &:hover {\n        text-decoration: underline;\n      }\n\n      svg {\n        width: ", ";\n        height: ", ";\n        vertical-align: text-bottom;\n        margin-right: 6px;\n      }\n    "])), GlobalNavigation_styles_1.navigationTriggerStyles, isTrainingOrg ? GlobalNavigation_styles_1.navigationTrainingTheme : GlobalNavigation_styles_1.navigationTheme(isDiligentBrand), tokens_1.default.color.blackLighten70, stylers_1.default.fontSize(-1), svgWidthHeight, svgWidthHeight);
}));
var templateObject_1, templateObject_2;
//# sourceMappingURL=LaunchpadLink.styles.js.map